export default __webpack_public_path__ + "static/media/24w.0a727d79.svg";